module.exports = __webpack_public_path__ + "img/41csm_Ersa-Wave-POWERFLOWPRO-1140370-1005x600_3baf7837bd.28eebe31.jpg";